export default __webpack_public_path__ + "static/media/IMG3208.2c617dc5.jpg";